const DEVICE_ID_KEY = 'tark_web_device_id';

function getStoredDeviceId(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage.getItem(DEVICE_ID_KEY);
  } catch {
    return null;
  }
}

function storeDeviceId(deviceId: string) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(DEVICE_ID_KEY, deviceId);
  } catch {
    // Ignore storage failures and continue with the generated ID.
  }
}

export function getOrCreateWebDeviceId(): string {
  const existing = getStoredDeviceId();
  if (existing) {
    return existing;
  }

  const created =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `tark-web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

  storeDeviceId(created);
  return created;
}

function detectBrowserName(): string {
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Edg/')) return 'Edge';
  if (userAgent.includes('Chrome/')) return 'Chrome';
  if (userAgent.includes('Firefox/')) return 'Firefox';
  if (userAgent.includes('Safari/') && !userAgent.includes('Chrome/')) return 'Safari';

  return 'Browser';
}

export function getWebDeviceMetadata() {
  const browserName = detectBrowserName();
  const navigatorWithUAData = navigator as Navigator & {
    userAgentData?: {
      platform?: string;
    };
  };
  const platform = navigatorWithUAData.userAgentData?.platform || navigator.platform || 'Desktop';

  return {
    deviceId: getOrCreateWebDeviceId(),
    deviceType: 'web' as const,
    deviceName: `${browserName} on ${platform}`,
    osVersion: navigator.userAgent,
    appVersion: import.meta.env.VITE_APP_VERSION || 'web-1.0.0',
  };
}
